module.exports = __webpack_public_path__ + "img/list3.f2fbe5bd.png";